const categories_rider = [
    {
        title: {
            de: "Reitstiefeletten und Chaps",
            nl: "Jodhpurs en Chaps"
        },
        description: {
            de: `Egal, ob du gerade erst mit dem Reiten beginnst oder schon seit Jahren im Sattel sitzt: Gute Reitausrüstung macht den Unterschied. Unsere Auswahl an Reitstiefeletten und Chaps verbindet Stil, Komfort und Funktionalität, damit du dich voll auf deinen Ritt konzentrieren kannst.

Unsere Produkte eignen sich sowohl für Anfänger als auch für fortgeschrittene Reiter und bieten ein ausgezeichnetes Preis-Leistungs-Verhältnis.

Warum unsere Reitstiefeletten und Chaps?`,
            nl: `Of je nu net begint met paardrijden of al jaren in het zadel zit: goede rijuitrusting maakt het verschil. Onze collectie jodhpurs en chaps combineert stijl, comfort en functionaliteit, zodat jij je volledig kunt focussen op jouw rit.

Onze producten zijn geschikt voor zowel beginners als gevorderde ruiters en bieden een uitstekende prijs-kwaliteitverhouding.

Waarom kiezen voor onze jodhpurs en chaps?`
        },
        bullets: {
            de: [
                "Schließen schön an und bieten optimale Bewegungsfreiheit",
                "Mehr Stabilität und Kontrolle beim Reiten",
                "Zusätzlicher Schutz für die Unterschenkel",
                "Mehr Halt im Sattel",
                "Bequem und einfach anzuziehen",
                "Ideal kombinierbar mit Reitstiefeletten"
            ],
            nl: [
                "Sluiten mooi aan en bieden optimale bewegingsvrijheid",
                "Meer stabiliteit en controle tijdens het rijden",
                "Extra bescherming van je onderbenen",
                "Meer grip in het zadel",
                "Comfortabel en eenvoudig aan te trekken",
                "Ideaal te combineren met jodhpurs"
            ]
        },
        image: "images_general/horse_eq_6.webp"
    },
    {
        title: {
            de: "Reithelme",
            nl: "Rijhelmen"
        },
        description: {
            de: `Sicheres Reiten beginnt mit dem richtigen Reithelm.

Egal, ob du Anfänger bist oder täglich im Sattel sitzt: Ein guter Reithelm ist unverzichtbar. Sicherheit, Komfort und Stil kommen in unserer Helmauswahl zusammen, damit du mit Vertrauen reiten kannst.

Beim Reiten können unerwartete Situationen entstehen. Ein Reithelm schützt deinen Kopf bei einem Sturz oder Zusammenstoß und verringert das Risiko schwerer Verletzungen deutlich. Deshalb ist das Tragen eines zugelassenen Helms kein Luxus, sondern ein Muss.

Ein Helm muss nicht nur sicher sein, sondern auch angenehm sitzen. Deshalb findest du bei uns:`,
            nl: `Veilig rijden begint met de juiste paardrijhelm.

Of je nu een beginnende ruiter bent of dagelijks in het zadel zit: een goede paardrijhelm is onmisbaar. Veiligheid, comfort en stijl komen samen in onze collectie helmen, zodat jij met vertrouwen kunt rijden.

Tijdens het rijden kunnen onverwachte situaties ontstaan. Een paardrijhelm beschermt je hoofd bij een val of botsing en vermindert de kans op ernstig letsel aanzienlijk. Daarom is het dragen van een goedgekeurde helm geen luxe, maar een must.

Een helm moet niet alleen veilig zijn, maar ook prettig zitten. Daarom vind je bij ons:`
        },
        bullets: {
            de: [
                "Verstellbare Größen für eine perfekte Passform",
                "Gute Belüftung für optimalen Tragekomfort",
                "Leichte Materialien",
                "Weiches, atmungsaktives Innenfutter"
            ],
            nl: [
                "Verstelbare maten voor een perfecte fit",
                "Goede ventilatie voor optimaal draagcomfort",
                "Lichtgewicht materialen",
                "Zachte, ademende voering"
            ]
        },
        image: "images_general/horse_eq_3.webp"
    },
    {
        title: {
            de: "Reitbekleidung",
            nl: "Paardrijkleding"
        },
        description: {
            de: `Unser Basissortiment an Reitbekleidung ist sorgfältig für jeden Reiter zusammengestellt, dem Komfort, Funktionalität und eine gute Passform wichtig sind. Egal, ob du freizeitmäßig reitest oder regelmäßig im Sattel sitzt: Mit dieser Auswahl bist du immer gut vorbereitet.

In unserem Basissortiment findest du bequeme und langlebige Reithosen in verschiedenen Modellen. Die Hosen bestehen aus flexiblen, atmungsaktiven Materialien, die beim Reiten optimale Bewegungsfreiheit bieten. Durch die stabile Passform und elastischen Stoffe sitzen sie angenehm und bleiben auch bei längeren Ritten bequem.

Kombiniere sie mit unserer praktischen und bequemen Basis-Oberbekleidung für ein vollständiges, funktionales Reiteroutfit.

Mit diesem Basissortiment entscheidest du dich für Qualität, Einfachheit und Zuverlässigkeit zu einem fairen Preis – alles, was du brauchst, um gut vorbereitet zu reiten.`,
            nl: `Ons basisassortiment paardrijkleding is zorgvuldig samengesteld voor iedere ruiter die comfort, functionaliteit en een goede pasvorm belangrijk vindt. Of je nu recreatief rijdt of regelmatig in het zadel zit, met deze selectie ben je altijd goed voorbereid.

In ons basisassortiment vind je comfortabele en duurzame rijbroeken in verschillende modellen. De broeken zijn gemaakt van soepele, ademende materialen die optimale bewegingsvrijheid bieden tijdens het rijden. Dankzij de stevige pasvorm en elastische stoffen sluiten ze goed aan en blijven ze prettig zitten, ook tijdens langere ritten.

Combineer ze met onze praktische en comfortabele basis bovenkleding voor een complete, functionele ruiteroutfit.

Met dit basisassortiment kies je voor kwaliteit, eenvoud en betrouwbaarheid voor een scherpe prijs, alles wat je nodig hebt om goed voorbereid te rijden.`
        },
        bullets: {
            de: [],
            nl: []
        },
        image: "images_general/horse_eq_2.webp"
    },
    {
        title: {
            de: "Reithandschuhe",
            nl: "Handschoenen"
        },
        description: {
            de: `Reithandschuhe sind ein wichtiger Bestandteil der Ausrüstung jedes Reiters, sowohl für Anfänger als auch für erfahrene Reiterinnen und Reiter. Sie sorgen nicht nur für zusätzlichen Halt an den Zügeln, sondern schützen die Hände auch vor Reibung, Blasen und Kälte. Beim Reiten ist ein stabiler und angenehmer Griff entscheidend. Handschuhe helfen dabei, den Kontakt zu den Zügeln zu verbessern, besonders bei nassem Wetter oder wenn die Zügel glatt werden.

Gute Reithandschuhe bestehen aus robusten Materialien wie synthetischem Leder, echtem Leder oder elastischen Stoffen, die sich gut mit der Hand mitbewegen. Dadurch behält der Reiter genug Gefühl in den Fingern, um fein und präzise über die Zügel mit dem Pferd zu kommunizieren.`,
            nl: `Rijhandschoenen zijn een belangrijk onderdeel van de uitrusting van iedere ruiter, zowel voor beginners als voor ervaren amazones en ruiters. Ze zorgen niet alleen voor extra grip op de teugels, maar beschermen ook de handen tegen wrijving, blaren en kou. Tijdens het rijden is een stabiele en comfortabele grip essentieel, en handschoenen helpen daarbij doordat ze het contact met de teugels verbeteren, vooral bij nat weer of wanneer de teugels glad worden.

Goede rijhandschoenen zijn gemaakt van sterke materialen zoals synthetisch leer, echt leer of elastische stoffen die goed meebewegen met de hand. Dit zorgt ervoor dat de ruiter voldoende gevoel in de vingers behoudt om subtiel met het paard te communiceren via de teugels.`
        },
        bullets: {
            de: [],
            nl: []
        },
        image: "images_general/horse_eq_1.webp"
    },
    {
        title: {
            de: "Gerten und Sporen",
            nl: "Zwepen en sporen"
        },
        description: {
            de: `Entdecke unsere Auswahl an Gerten und Sporen, entwickelt für Präzision, Komfort und eine optimale Kommunikation zwischen Reiter und Pferd. Egal, ob du auf hohem Niveau trainierst oder freizeitmäßig reitest: Die richtige Ausrüstung macht den Unterschied bei Kontrolle und feiner Hilfengebung.

Unsere Gerten sind leicht, ausgewogen und langlebig, sodass du sie mühelos führen kannst, ohne auf Gefühl und Kontrolle zu verzichten. Die Sporen in unserem Sortiment sind komfortabel geformt und bieten eine subtile, effektive Unterstützung beim Reiten.

Verbessere deine Reittechnik mit Ausrüstung, die Vertrauen gibt und Leistung unterstützt – und wähle die perfekte Kombination für deine Disziplin.

Reite mit Gefühl. Reite mit Kontrolle.`,
            nl: `Ontdek onze collectie zwepen en sporen, ontworpen voor precisie, comfort en optimale communicatie tussen ruiter en paard. Of je nu traint op hoog niveau of recreatief rijdt, de juiste uitrusting maakt het verschil in controle en verfijning van je hulpen.

Onze zwepen zijn licht, uitgebalanceerd en duurzaam, zodat je ze moeiteloos hanteert zonder in te leveren op gevoel en controle. De sporen in ons assortiment zijn comfortabel gevormd en bieden subtiele, effectieve ondersteuning tijdens het rijden.

Verbeter je rijtechniek met uitrusting die vertrouwen geeft en prestaties ondersteunt, en kies de perfecte combinatie voor jouw discipline.

Rij met gevoel. Rij met controle.`
        },
        bullets: {
            de: [],
            nl: []
        },
        image: "images_general/horse_eq_3.webp"
    }
];

export default categories_rider;
